"use client";
import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/app/admin/_common/ui/dropdown-menu";
import GuestService from "@/app/_services/GuestService";
import GuestDetailsDrawer from "./dialogs/GuestDetailsDrawer";
import RefundDialog from "./dialogs/RefundDialog";
import SwapDialog from "./dialogs/SwapDialog";
import EmailDialog from "./dialogs/EmailDialog";
import { Eye, ArrowLeftRight, Mail, MoreHorizontal } from "lucide-react";

export default function GuestTableMenu({
  order,
  show,
  showId,
  futureShows,
  onChanged,
}: {
  order: any;
  show?: any;
  showId?: string;
  futureShows?: any[];
  onChanged?: () => void;
}) {
  const { comped } = order;
  const [viewOpen, setViewOpen] = useState(false);
  const [refundOpen, setRefundOpen] = useState(false);
  const [swapOpen, setSwapOpen] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);
  const [orderWithShows, setOrderWithShows] = useState(order);

  async function handleView() {
    if (order?.guest_data?.id) {
      try {
        const prevShows = await GuestService.getGuestShows(order.guest_data.id);
        const previous_shows = (prevShows || []).map((s: any) => ({
          show_name: s.variant_name ? `${s.title}: ${s.variant_name}` : s.title,
          timestamp: s.start,
        }));
        setOrderWithShows({ ...order, previous_shows });
      } catch (err) {
        console.error("Failed to fetch guest shows", err);
        setOrderWithShows(order);
      }
    } else {
      setOrderWithShows(order);
    }
    setViewOpen(true);
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="ml-auto inline-flex size-[30px] flex-none items-center justify-center rounded-md text-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
          >
            <MoreHorizontal className="size-4 shrink-0" size={16} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={handleView}>
            <Eye className="mr-2 size-4" />
            View details
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setRefundOpen(true)}>
            <ArrowLeftRight className="mr-2 size-4" />
            {comped ? "Uncomp" : "Refund"}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setSwapOpen(true)}>
            <ArrowLeftRight className="mr-2 size-4" />
            Swap show
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setEmailOpen(true)}>
            <Mail className="mr-2 size-4" />
            Resend email
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <GuestDetailsDrawer open={viewOpen} onClose={() => setViewOpen(false)} order={orderWithShows} />
      <RefundDialog open={refundOpen} onClose={() => setRefundOpen(false)} order={order} onSuccess={onChanged} />
      <SwapDialog
        open={swapOpen}
        onClose={() => setSwapOpen(false)}
        order={order}
        showId={showId ?? show?.id}
        futureShows={futureShows}
        onSuccess={onChanged}
      />
      <EmailDialog open={emailOpen} onClose={() => setEmailOpen(false)} order={order} onSuccess={onChanged} />
    </>
  );
}
